import {DiscountType} from 'Coupon/constants/DiscountType';

export function withCurrency(value: string | number) {
  return `${value < 0 ? '-$' : '$'}${Math.abs(Number(value))}`;
}

export function withCurrencyOrPercent(value: string | number, type: DiscountType) {
  return type === DiscountType.Amount ? `$${value}` : `${value}%`;
}
